import { createAsyncAction } from 'typesafe-actions'

import { DateFormat, format } from 'packages/utils/dateHelpers'
import {
  RequestConfig,
  RequestOptions,
} from 'packages/utils/store/jsonapi.types'

import { crossCoverageService } from '../crossCoverage.service'
import {
  CrossCoverageApiFields,
  CrossCoverageActionTypes,
  NormalizedCrossCoverageApiResponse,
} from '../crossCoverage.types'

export const fetchCrossCoveragesAction = createAsyncAction(
  CrossCoverageActionTypes.FETCH_CROSS_COVERAGES,
  CrossCoverageActionTypes.FETCH_CROSS_COVERAGES_SUCCESS,
  CrossCoverageActionTypes.FETCH_CROSS_COVERAGES_FAILURE,
)<
  RequestConfig<NormalizedCrossCoverageApiResponse>,
  NormalizedCrossCoverageApiResponse,
  Error
>()

type Params = {
  startDateGte?: Date
  userCovered?: string
}

export const getParams = (params: Params) => {
  let normalizedParams: RequestOptions = {}

  if (params.startDateGte) {
    normalizedParams = {
      ...normalizedParams,
      filter: {
        ...normalizedParams.filter,
        start_date: {
          gte: format(params.startDateGte, DateFormat.ApiUtcShort),
        },
      },
    }
  }

  if (params.userCovered) {
    normalizedParams = {
      ...normalizedParams,
      filter: {
        ...normalizedParams.filter,
        user_covered: params.userCovered,
      },
    }
  }

  return {
    fields: {
      crossCoverage: CrossCoverageApiFields,
    },
    include: ['user_covered', 'user_covering'],
    ...normalizedParams,
  }
}

export const fetchCrossCoverages =
  (params: Params) => async (dispatch, getState) => {
    try {
      if (params.userCovered === undefined) {
        params.userCovered = getState().users.activeUserId
      }

      const request = crossCoverageService.fetchCrossCoverages.bind(
        null,
        getParams(params),
      )
      const result = await dispatch(
        fetchCrossCoveragesAction.request({ request }),
      )

      dispatch(fetchCrossCoveragesAction.success(result))
      return result.normalized
    } catch (error) {
      dispatch(fetchCrossCoveragesAction.failure(error))
      throw error
    }
  }
